import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Network, User, Building2, Calendar } from 'lucide-react';
import { cn } from '@/components/ui/utils';

const tabs = [
  { label: 'Dashboard', href: '/connects', icon: Network, exact: true },
  { label: 'Contacts', href: '/connects/contacts', icon: User },
  { label: 'Companies', href: '/connects/companies', icon: Building2 },
  { label: 'Digests', href: '/connects/digests', icon: Calendar },
];

export function ConnectsLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (href: string, exact?: boolean) => {
    if (exact) return location.pathname === href;
    return location.pathname.startsWith(href);
  };

  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      {/* Sub-nav */}
      <div className="border-b px-4 lg:px-6 overflow-x-auto">
        <nav className="flex gap-1 -mb-px min-w-max">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const active = isActive(tab.href, tab.exact);
            return (
              <button
                key={tab.href}
                onClick={() => navigate(tab.href)}
                className={cn(
                  'flex items-center gap-1.5 px-3 py-3 text-sm font-medium border-b-2 transition-colors',
                  active
                    ? 'border-foreground text-foreground'
                    : 'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
                )}
              >
                <Icon className="h-4 w-4" />
                {tab.label}
              </button>
            );
          })}
        </nav>
      </div>
      <div className="flex flex-1 flex-col overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
}
